import React from 'react';
import './css/Become.css';

export default () => (
  <>
    <p className="subscribe">
      <a href="http://eepurl.com/rfV9n" target="_blank" rel="noreferrer">Subscribe to our newsletter</a>
    </p>
    <iframe src="https://divamodels.tumblr.com//" width="100%" height="600px" frameborder="0"/>
  </>
);
